import { ModalWindow } from "../../UI/ModalWindow";
import { Input, Select } from '../../UI/FormElements'

const ROUTE_URL = "/objects";
const initialData = { object_type: "МС", status: "0", address: "", link: "" };

function ModalObservationObjects({ params, handleClose }) {
  let urlSubmit, urlGet;
  if (params.isNew) {
    urlSubmit = ROUTE_URL;
    urlGet = ""; //или ROUTE_URL + "/create" если при создании НАДО предварительное обращение к серверу

  }
  else {
    urlGet = ROUTE_URL + "/" + params.id;
    urlSubmit = urlGet;

  }

  return (
    <ModalWindow params={params} handleClose={handleClose} initialData={initialData} urlGet={urlGet} urlSubmit={urlSubmit} >
      <IncidentCardsFields />
    </ModalWindow>
  );
}
let categoryTypes = [{ id: 1, name: "МС" }, { id: 2, name: "ПУ-ЛСН" }, { id: 3, name: "НАП" }, { id: 4, name: "КНАП" }, { id: 5, name: "Тревожные кнопки" }];

const IncidentCardsFields = ({ dopParams, ...elementProps }) => {
  return (
    <div className="row form-gutter">
      <div className="col-12 rowcols">
        <div className="rowcol">
          {/* <Input label="Вид объекта" name="object_type" {...elementProps} required /> */}
          <Select label="Вид объекта" name="object_type" {...elementProps} selectOptions={categoryTypes} required />
        </div>
        <div className="rowcol checkbox">
          <Input type="checkbox" className="form-check-input actcheck" label="Включен" name="status" {...elementProps} onChange={(e) => e.target.checked ? elementProps.data.status = 1 : elementProps.data.status = 0} />
        </div>
      </div>
      <div className="col-12">
        <Input label="Местоположение" name="address"  {...elementProps} required autoFocus />
      </div>
      <div className="col-12">
        <Input label="Ссылка" name="link"  {...elementProps} required autoFocus />
      </div>
    </div>
  )
}
export default ModalObservationObjects;
